import { SVGProps } from 'react';

export const EmptyResults = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="141"
    height="141"
    viewBox="0 0 141 141"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M56.3215 78.3002C56.3215 65.0559 67.0559 54.3215 80.3002 54.3215C85.2318 54.3215 89.8117 55.8135 93.6217 58.3659V46.3286C93.6217 43.3925 91.2318 41 88.2931 41H48.3286C45.3899 41 43 43.3925 43 46.3286V86.2931C43 89.2318 45.3899 91.6217 48.3286 91.6217H60.3659C57.8135 87.8117 56.3215 83.2318 56.3215 78.3002Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M86.6346 73.3112L85.6066 72.2832L80.3046 77.5852L75.0026 72.2832L73.9746 73.3112L79.2766 78.6132L73.9746 83.9152L75.0026 84.9432L80.3046 79.6412L85.6066 84.9432L86.6346 83.9152L81.3326 78.6132L86.6346 73.3112Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M66.9793 78.2981C66.9793 70.9526 72.9553 64.9766 80.3007 64.9766C87.6462 64.9766 93.6222 70.9526 93.6222 78.2981C93.6222 85.6436 87.6462 91.6196 80.3007 91.6196C72.9553 91.6196 66.9793 85.6436 66.9793 78.2981ZM107.04 99.4797L95.9593 88.3989C97.843 85.4842 98.9513 82.0206 98.9513 78.2986C98.9513 68.0144 90.5854 59.6485 80.3012 59.6485C70.017 59.6485 61.6511 68.0144 61.6511 78.2986C61.6511 88.5827 70.017 96.9486 80.3012 96.9486C83.9726 96.9486 87.3936 95.8669 90.2817 94.0259L101.386 105.131L107.04 99.4797Z"
      fill="currentColor"
    />
  </svg>
);
